import { render, staticRenderFns } from "./toggle-emails.vue?vue&type=template&id=be042754"
import script from "./toggle-emails.vue?vue&type=script&lang=js"
export * from "./toggle-emails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports